const Menu = {
  isOpened: false,
  header: document.querySelector('.md-nav-box'),
  burgerIcon: document.querySelector('.md-menu-toggle'),

  show() {
    document.body.classList.add('hidden-scroll-on-mobile');
    this.header.classList.add('is-active');
    document.addEventListener('click', outsideClose);
    this.isOpened = true;
  },

  hide() {
    document.body.classList.remove('hidden-scroll-on-mobile');
    this.header.classList.remove('is-active');
    document.removeEventListener('click', outsideClose);
    this.isOpened = false;
  },

  toggle(state) {
    if (state === true || !this.isOpened) {
      return this.show();
    }
    this.hide();
  },
};

function outsideClose(event) {
  if (!event.target.closest('.md-nav-box, .md-menu-toggle')) {
    Menu.hide();
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./resources/assets/js/menu-item.js